import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { CheckoutModal } from './checkout.modal';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    PipesModule
  ],
  declarations: [CheckoutModal],
  entryComponents: [
    CheckoutModal
  ],
  exports: [
    CheckoutModal
  ]
})
export class CheckoutModalModule {}
